/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Send_Voice_Messages_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to send voice messages." |
*
* @param {Leveling_Perm_Send_Voice_Messages_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_send_voice_messages_hint = /** @type {((inputs?: Leveling_Perm_Send_Voice_Messages_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Send_Voice_Messages_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отправлять голосовые сообщения.")
	return /** @type {LocalizedString} */ ("Allows members to send voice messages.")
});